<template>
  <div>
    <common-dialog
      class="forum-dialog"
      center
      @close="handlerClose"
      :close-on-click-modal="false"
      :title="discuss.type ==='add'?'添加成员':'移除成员'"
      :visible.sync="dialogVisible"
      width="70%">
      <div class="detail-panel">
        <div class="panel-left">
          <div class="member-search">
            <i class="search-input-icon icon-sousuo iconfont"></i>
            <input type="text" class="search-input" v-model="keyword">
            <i class="clear-input-icon icon-tianjia iconfont" @click="clearSearchCondition"></i>
          </div>
          <div class="member-list">
            <div v-for="(item,index) of discuss.users" :key="item.userId">
              <el-row>
                <div class="member-list-item">
                  <el-checkbox v-model="item.checked" class="item-checkbox" :key="item.userId">
                    <span class="member-list-avatar"
                          :style="`background-image: url(${avatarPre}/${item.avatar}`"></span>
                    <span class="member-list-text">
                       <span class="member-list-name">{{ item.name }}</span>
                        <span class="member-list-userId">手机号：{{ item.userId }}</span>
                    </span>
                  </el-checkbox>
                </div>
              </el-row>
            </div>

          </div>
        </div>
        <div class="panel-right">
          <div class="member-list-invite">
            <el-row :gutter="20">
              <div v-for="(item,index) of members" :key="index">
                <el-col :span="memberSpan">
                     <span class="member-item">
                        <div class="remove-item-btn icon-tianjia iconfont" @click="handleRemoveMember(item)"></div>
                        <div class="member-item-up"
                             :style="`background-image: url(${avatarPre}/${item.avatar}`"></div>
                        <div class="member-item-down">
                          <div class="user-name" :title="item.name">{{ item.name }}</div>
                        </div>
                    </span>
                </el-col>
              </div>
            </el-row>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <common-button @click="dialogVisible = false" type="cancel" image size="default">取 消</common-button>
        <common-button type="primary" @click="handleSaveMember" image size="default">确 定</common-button>
      </span>
    </common-dialog>
    <!--加载动画-->
    <animation :loadingDataVisible="isLoading"></animation>


  </div>
</template>

<script>
import {generateStandardSpan} from "@/utils/acquireStandardSpan";
import http from '@/utils/axios'
import cookie from "@/utils/cookie";
import {Message} from "element-ui";
import animation from '@/components/loading/animation'

export default {
  name: "ForumDetail",
  components: {animation},
  data() {
    return {
      that: this,
      keyword: null,
      searchTimeout: null,
      memberSensitive: 80,
      memberSpan: 6,
      avatarPre: window.config.avatar.baseUrl,
      dialogVisible: false,
      discuss: {
        users: [],
        attachments: [],
      },
      //被邀请的成员信息
      members: [],
      isLoading: false,
      currentUserId: '',
    }

  },

  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        //查询用户列表数据
        this.initData();
      }
    },

    keyword(newVal) {
      this.searchConditionChange()
    },

    'discuss.users': {
      deep: true,
      handler(newVal) {
        for (let item of newVal) {
          if (item.checked) {
            //查询是否有这个数据
            let data = this.members.find(ev => {
              return ev.userId === item.userId
            })
            if (this.members.length === 0 || !data) {
              this.members.push(item)
            }
          } else {
            //取消选中将选中的数据移除
            for (let i = 0; i < this.members.length; i++) {
              let member = this.members[i]
              if (member.userId === item.userId) {
                this.members.splice(i, 1)
              }
            }
          }
        }
      },
    }
  },

  mounted() {
    this.initPage()

  },

  //销毁时销毁监听器
  beforeDestroy() {
    window.removeEventListener("resize", this.timeOutChange)
  },
  methods: {

    handleSaveMember() {
      if (this.discuss.type === 'add') {
        this.inviteMember()
      } else if (this.discuss.type === 'remove') {
        this.removeMember()
      }
    },

    //邀请用户
    inviteMember() {
      let that = this

      let userIds = this.members.map(item => {
        return item.userId
      })

      if (userIds.length === 0) {
        Message.error("请至少邀请一个用户")
        return
      }
      this.isLoading = true

      http.post(window.config.api.baseUrl + '/eims-api/discuss/inviteMember', {
        token: cookie.getCookie("token"),
        data: {
          userIds: userIds,
          postCode: that.discuss.postCode,
        }
      }).then(value => {
        if (value.data.code === '00000') {
          if (that.currentUserId === that.discuss.createUserId) {
            Message.success({message: '用户邀请加入成功', showClose: true})
          } else {
            Message.success({message: '邀请用户信息提交成功', showClose: true})
          }
          that.dialogVisible = false
          that.$emit("initData")
        }
      }).finally(() => {
        that.isLoading = false

      })
    },

    //踢出用户
    removeMember() {
      let that = this
      let userIds = this.discuss.users.filter(item => {
        return item.checked === false
      }).map(item => {
        return item.userId
      })
      if (userIds.length === 0) {
        Message.error("请至少选择一个用户")
        return
      }
      this.isLoading = true
      http.post(window.config.api.baseUrl + '/eims-api/discuss/removeMember', {
        token: cookie.getCookie("token"),
        data: {
          userIds: userIds,
          postCode: that.discuss.postCode,
        }
      }).then(value => {
        if (value.data.code === '00000') {
          Message.success({message: '用户已经被踢出', showClose: true})
          that.dialogVisible = false
          that.$emit("initData", '')
        }
      }).finally(() => {
        that.isLoading = false

      })
    },

    handleRemoveMember(item) {
      //移除members中的数据
      this.members.splice(this.members.indexOf(item), 1)

      //移除users中的选中状态
      for (let user of this.discuss.users) {
        if (user.userId === item.userId) {
          user.checked = false
        }
      }
    },

    clearSearchCondition() {
      this.keyword = null
    },

    searchConditionChange() {
      //防抖节流
      let that = this
      if (this.searchTimeout != null) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = null
      }
      this.searchTimeout = setTimeout(() => {
        that.initData()
      }, 200)

    },

    initData() {
      if (this.discuss.type === 'add') {
        this.inviteMemberList()
      } else if (this.discuss.type === 'remove') {
        this.removeMemberList()
      }
    },


    removeMemberList() {
      let that = this
      this.isLoading = true
      http.post(window.config.api.baseUrl + '/eims-api/discuss/member/removeList', {
        token: cookie.getCookie("token"),
        data: {
          keyword: that.keyword,
          postCode: that.discuss.postCode,
        }
      }).then((response) => {
        let data = response.data.data;
        that.discuss.users = []
        //设置数据的选中状态
        for (let item of data.members) {
          let data = that.members.find(member => {
            return member.userId === item.userId
          })

          //第一次访问时
          if (that.members.length === 0) {
            //添加数据的选中状态
            item.checked = true
          } else {
            for (let member of that.members) {
              if (member.userId === item.userId) {
                item.checked = true
                break
              }
            }
          }
          that.discuss.users.push(item)
        }

      }).finally(() => {
        that.isLoading = false;
      });
    },

    inviteMemberList() {
      let that = this
      this.isLoading = true
      http.post(window.config.api.baseUrl + '/eims-api/discuss/member/query', {
        token: cookie.getCookie("token"),
        data: {
          keyword: that.keyword,
          postCode: that.discuss.postCode,
        }
      }).then((response) => {
        let data = response.data.data;
        that.discuss.users = []
        //设置数据的选中状态
        for (let item of data.members) {
          let data = that.members.find(member => {
            return member.userId === item.userId
          })
          //添加数据的选中状态
          if (data) {
            item.checked = true
          }
          that.discuss.users.push(item)
        }


      }).finally(() => {
        that.isLoading = false;
      });
    },

    initPage() {
      window.addEventListener("resize", this.timeOutChange, false);
    },

    handlerClose() {
      this.dialogVisible = false

    },

    changeDialogStatus(status, discuss, type, currentUserId) {
      this.currentUserId = currentUserId
      this.discuss.postCode = discuss.postCode
      this.discuss.userId = discuss.userId

      this.discuss.type = type
      this.discuss.users = []
      this.members = []
      this.dialogVisible = status
      if (this.dialogVisible) {
        let that = this
        setTimeout(() => {
          that.windowSizeChange()
        }, 10)
      }

    },

    timeOutChange() {
      let that = this
      if (this.spanTimeout !== null) {
        clearTimeout(this.spanTimeout)
        this.spanTimeout = null
      }

      this.spanTimeout = setTimeout(() => {
        that.windowSizeChange()
      }, 10)
    },

    //窗口发生变化
    windowSizeChange() {
      if (this.dialogVisible) {
        let memberPanel = document.getElementsByClassName("member-list-invite")[0]
        this.memberSpan = generateStandardSpan(memberPanel.offsetWidth, this.memberSensitive)
      }
    },
  }
}
</script>

<style scoped>

.detail-panel {
  width: 100%;
  height: 60vh;
}

.panel-left {
  float: left;
  width: calc(40% - 10px);
  height: 100%;
}

.panel-right {
  height: 100%;
  width: calc(60% - 10px);
  float: right;
}

.discuss-content >>> .el-textarea__inner {
  height: 20vh;
}

.member-list {
  margin: 10px;
  width: 100%;
  height: calc(100% - 30px);
  overflow-y: auto;
  overflow-x: hidden;
}

.member-list-item {
  width: 100%;
  height: 60px;

}

.member-list-item:before {
  content: '';
  width: calc(100% - 78px);
  height: 59px;
  border-bottom: rgba(222, 218, 218, 0.5) 1px solid;
  position: absolute;
  left: 78px;
}

.member-list-item:hover {
  cursor: pointer;
  background-color: rgba(222, 218, 218, 0.5);
}

/*   >>>深度选择器*/
.item-checkbox >>> .el-checkbox__inner {
  margin: 23px 0;
}

/*   >>>深度选择器*/
.item-checkbox >>> .el-checkbox__input {
  vertical-align: top;
}

.item-checkbox {
  display: flex;
  flex-direction: row;
}

.member-list-avatar {
  border-radius: 2px;
  border: 1px solid #e5e4e4;
  display: inline-block;
  margin: 10px 0;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.member-list-text {
  padding: 10px;
  vertical-align: top;
  display: inline-block;
  flex: 1;
  height: 60px;
}


.member-list-name {
  font-size: 16px;
  display: block;
}

.member-list-userId {
  font-size: 14px;
  display: block;
}

.member-list-invite {
  margin: 10px;
  border-radius: 10px;
  padding: 5px 10px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  height: calc(100% - 10px);
}


.member-item {
  position: relative;
  display: inline-block;
}

.member-item-up {
  border-radius: 5px;
  border: 3px solid #e2dddd;
  background-size: cover;
  width: 50px;
  height: 50px;
  margin: 5px auto;
}

.member-item-down {
  font-size: 14px;
  width: 50px;
  margin: 0 auto;
}

.user-name {
  line-height: 20px;
  text-align: center;
  width: 100%;
  /*将元素设置行内块元素，否则下面的设置将会无效*/
  display: inline-block;
  /*将超出的文本隐藏*/
  overflow: hidden;
  /*设置文本超出span长度之需要设置为不换行*/
  white-space: nowrap;
  /*将溢出的文本使用...显示*/
  text-overflow: ellipsis;
}

.remove-item-btn {
  position: relative;
  top: 16px;
  right: -43px;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: #6e6e6e55;
  border-radius: 100%;
}

.icon-tianjia {
  line-height: 18px;
  cursor: pointer;
  color: #FFFFFF;
  transform: rotate(45deg);
}

.member-search {
  position: relative;
}

.search-input {
  width: calc(100% - 5px);
  height: 35px;
  margin: 2.5px;
  padding: 2px 30px;
  border: 1px solid #afafaf;
  border-radius: 5px;
}

.search-input:focus {
  outline: none;
}

.search-input-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  z-index: 999;
  position: absolute;
  top: 6px;
  left: 10px;
}

.clear-input-icon {
  line-height: 22px;
  color: #b2b2b2;
  display: inline-block;
  width: 20px;
  height: 20px;
  z-index: 999;
  position: absolute;
  top: 11px;
  right: 10px;
}

.panel-right-down {
  overflow-y: auto;
  height: 50%;
  padding: 10px;
}


</style>



// WEBPACK FOOTER //
// src/components/detail/ForumInvite.vue